import { format } from "date-fns";

export default function formatDateTime(d: Date | null | undefined): string {
  if (!d || isNaN(d.getTime())) {
    return '';
  }
  return format(d, "yyyy-MM-dd'T'HH:mm");
}
